import {LinePlotTemplateSettings} from '../../../graphql/workspaceTemplates';
import {LinePlotDisplayRowFnType} from '../types';
import {
  getSmoothingTypeDisplayRow,
  getSmoothingWeightDisplayRow,
} from './smoothingDisplayValues';
import {getXAxisDisplayRow} from './xAxisDisplayValues';

export const LINE_PLOT_TEMPLATE_DISPLAY_FNS: Record<
  keyof LinePlotTemplateSettings,
  LinePlotDisplayRowFnType
> = {
  smoothingType: getSmoothingTypeDisplayRow,
  smoothingWeight: getSmoothingWeightDisplayRow,
  xAxis: getXAxisDisplayRow,
};
